import ManagerStartRatingScreen from './layouts/CustomManagerStartRating';
import MFSPlayer from './MFSPlayer';
import React from 'react';
import withAccessibilityTheme from './WithAccessibilityTheme';
import withSurveyFlow from './WithSurveyFlow';
import { AddRaterPage } from './raterNomination/AddRaterPage';
import { MfsForgotPasswordPage } from '../../authentication/components/mfs/MfsForgotPasswordPage';
import { MfsLoginPage } from '../../authentication/components/mfs/MfsLoginPage';
import { MfsStoreProvider } from '../store/mfsStore';
import { RaterNominationPage } from './raterNomination/RaterNominationPage';
import { routeMappings } from '../../constants';
import { RouteParams, RouteWithSubRoutes } from '../../base/components/Routes';
import { SearchRaterResultsPage } from './raterNomination/SearchRaterResultsPage';
import { Switch } from 'react-router-dom';
import { withBasicDetails } from '../../base/components/WithBasicDetails';
import { MfsAccountSelectionPage } from '../../authentication/components/mfs/MfsAccountSelectionPage';

const routes: RouteParams[] = [
  {
    path: `${routeMappings['MFS']}${routeMappings['LOGIN']}`,
    exact: true,
    component: MfsLoginPage,
  },
  {
    path: `${routeMappings['MFS']}${routeMappings['FORGOT_PASSWORD']}`,
    exact: true,
    component: MfsForgotPasswordPage,
  },
  {
    path: `${routeMappings['MFS']}${routeMappings['ACCOUNT_LOCKED']}`,
    exact: true,
    component: MfsForgotPasswordPage,
  },
  {
    path: `${routeMappings['MFS']}${routeMappings['ACCOUNT']}`,
    exact: true,
    component: MfsAccountSelectionPage,
  },
];

const surveyRoutes: RouteParams[] = [
  {
    path: `${routeMappings['MFS']}${routeMappings['MANAGER']}/:ratingId`,
    exact: true,
    component: MFSPlayer,
  },
  {
    path: `${routeMappings['MFS']}${routeMappings['PREVIEW']}/:sId/:questId/:raterId/:langId`,
    exact: true,
    component: MFSPlayer,
  },
];

const raterNominationRoutes: RouteParams[] = [
  {
    path: `${routeMappings['MFS']}${routeMappings['RATERS']}/:ratingId?`,
    exact: true,
    component: RaterNominationPage,
  },
  {
    path: `${routeMappings['MFS']}${routeMappings['ADD_NEW_RATER']}/:roleId?`,
    exact: true,
    component: AddRaterPage,
  },
  {
    path: `${routeMappings['MFS']}${routeMappings['SEARCH_RATER']}/:roleId?`,
    exact: true,
    component: AddRaterPage,
  },
  {
    path: `${routeMappings['MFS']}${routeMappings['SEARCH_RESULTS']}/:roleId?`,
    exact: true,
    component: SearchRaterResultsPage,
  },
  {
    path: `${routeMappings['MFS']}${routeMappings['START_SURVEY']}/:ratingId`,
    exact: true,
    component: ManagerStartRatingScreen,
  },
];

const MfsRoutes = (): JSX.Element => {
  return (
    <MfsStoreProvider>
      <Switch>
        {routes.map((route: RouteParams, i: number) => {
          route.component = withBasicDetails(route.component);
          return <RouteWithSubRoutes key={i} {...route} />;
        })}
        {surveyRoutes.map((route: RouteParams, i: number) => {
          route.component = withAccessibilityTheme(withSurveyFlow(route.component));
          return <RouteWithSubRoutes key={i} {...route} />;
        })}
        {raterNominationRoutes.map((route: RouteParams, i: number) => {
          route.component = withAccessibilityTheme(route.component);
          return <RouteWithSubRoutes key={i} {...route} />;
        })}
      </Switch>
    </MfsStoreProvider>
  );
};

export default MfsRoutes;
